const locale = process.env.REACT_APP_DEFAULT_LOCALE || 'en-IN';
const currency = process.env.REACT_APP_DEFAULT_CURRENCY || 'INR';

const formatter = new Intl.NumberFormat(locale, {
  style: 'currency',
  currency,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Format a number as currency using the app's configured locale and currency.
 * Change REACT_APP_DEFAULT_CURRENCY and REACT_APP_DEFAULT_LOCALE in .env to switch.
 */
export const formatCurrency = (amount: number | string | null | undefined): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  if (isNaN(num)) return formatter.format(0);
  return formatter.format(num);
};

/**
 * Returns just the currency symbol (e.g. "₹", "$") for use in input prefixes.
 */
export const getCurrencySymbol = (): string => {
  return formatter.formatToParts(0).find(p => p.type === 'currency')?.value ?? '₹';
};
